"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function toggleNotificationList(status) {
  return (0, _utils.actionCreator)(_types.TOGGLE_NOTIFICATION_LIST, status);
}
var _default = exports["default"] = toggleNotificationList;